import { Badge, Icon } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

const STATUSES = {
  new: {
    icon: 'status active',
    color: 'Label-Notice',
    bgColor: 'Background-Notice',
    label: 'agency::list.badges.new',
  },
  declined: {
    icon: 'status warning',
    color: 'Label-Error-Primary',
    bgColor: 'Background-Error',
    label: 'agency::list.badges.declined',
  },
  // active: {
  //   icon: 'status new',
  //   color: 'secondary-11',
  //   bgColor: 'secondary-65',
  //   label: 'agency::list.badges.active',
  // },
  archived: {
    icon: 'inbox-archive',
    color: 'Label-Fifth',
    bgColor: 'Background-Quaternary',
    label: 'agency::list.badges.archived',
  },
}

const StatusBadge = ({ status = null, ...rest }) => {
  const currentStatus = STATUSES?.[status]
  const { t } = useTranslation()

  if (!currentStatus) {
    return null
  }

  const { icon, label, bgColor, color } = currentStatus

  return (
    <Badge
      {...rest}
      bgColor={bgColor}
      color={color}
      startIcon={<Icon color={color} name={icon} width={16} />}
    >
      {t(label)}
    </Badge>
  )
}

export default StatusBadge

StatusBadge.propTypes = {
  status: PropTypes.string,
  className: PropTypes.string,
  component: PropTypes.elementType,
}
